// extracted by mini-css-extract-plugin
export default {"dropdown-arrow":"custom_dropdown-arrow__-5yLr","dropdown-value-container":"custom_dropdown-value-container__bwz-k","dropdown-wrapper":"custom_dropdown-wrapper__2YKZ3"};